module.exports = __webpack_public_path__ + "img/SKMJ_etc6.fdfc0027.jpg";